export const ISO = "iso3";
export const COUNTRY_NAME = "Country";
export const REGION_NAME = "region_name"; // the column name in the prevalence CSV files for the region name
export const COUNTRY_SHAPEFILE_REGION_NAME = "regn_nm"; // before we used REGNAME
export const DEFAULT_REGION_ID = "region_id"; // the column name on the prevalence CSV files
export const REGION_FIELD_SHAPEFILES = "regin_d"; // the column name on the shapefiles for every country
export const INDICATOR_ID = "Indicator";

export const COUNTRY = "country";
export const TEXT = "text";
export const INDICATOR = "indicator";
export const POPULATION = "pop_round";
